



import { defineComponent, computed } from '@nuxtjs/composition-api';
import { useConfigStore } from '~/stores/config';
import { getLayout } from '~/utils/helpers/page';

export default defineComponent({
  name: 'HomePage',
  layout(context) {
    return getLayout(context.i18n.locale);
  },
  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  setup() {
    const { storeConfig } = useConfigStore();

    const componentToRender = computed(() => {
      if (storeConfig.store_code === 'rinnovi') {
        return () => import(/* webpackPrefetch: true */ '~/pages/Rinnovi.vue');
      } else if (storeConfig.store_code == '24orepro') {
        return () => import(/* webpackPrefetch: true */ '~/pages/solepro/Home.vue');
      } else {
        return () => import(/* webpackPrefetch: true */ '~/pages/Landing/_utmCampaign/index.vue');
      }
    });

    return {
      componentToRender,
    };
  },
});
